<template>
  <cl-skeleton data-test-id="skeleton-loader" :loading-text="$t('loading')">
    <cl-skeleton-row />
    <cl-skeleton-row :bg="'light'" :width="'lg'" />
    <cl-skeleton-row :width="'sm'" />
    <cl-skeleton-row :bg="'light'" :width="'md'" />
    <cl-skeleton-row :width="'lg'" />
    <cl-skeleton-row :bg="'light'" :width="'sm'" />
  </cl-skeleton>
</template>
